import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
`;

export const Item = styled.button`
  width: ${({ count }) => `calc(100% / ${count})`};
  outline: none;
  padding: 14px 0;
  text-align: center;
  color: ${({ theme, active }) => (active ? theme.colors.tab.main : theme.colors.text.secondary)};
  font-size: ${({ theme }) => theme.fonts.text['font-size']};
  font-weight: ${({ theme }) => theme.fonts.text['font-weight']};
  line-height: ${({ theme }) => theme.fonts.text['line-height']};
  transition: 0.4s ease-in-out all;
  background: none;
  border: none;
  cursor: pointer !important;
  border-bottom: ${({ theme, active }) =>
    active ? `2px solid ${theme.colors.accent.main}` : `2px solid ${theme.colors.border.default}`};
`;
